import React, { useContext, useState, useEffect } from 'react';
import { Card, Tabs, Row, Col, Input } from 'antd';
import { PageHeader } from '@ant-design/pro-components';
import { observer } from 'mobx-react';
import { rootContext } from 'stores';
import './Recycle.scss';
import Part from './Part';
import Submodel from './Submodel';
import Trim from './Trim';
import { useDebouncedCallback } from 'use-debounce';

export type IFilterType = {
  [key: string]: string | null;
};

const { TabPane } = Tabs;
const Parts: React.FC = observer(() => {
  useEffect(() => {
    getAllDeletedItems(search, limit, offset, 'PART');
  }, []);

  const {
    RecycleStore: {
      state: {
        data: { offset, limit, tabel },
        ui: { recyclerLoading }
      },
      deleteItemForever,
      getAllDeletedItems,
      restoreItems,
      setState
    }
  } = useContext(rootContext);

  const [search, setSearch] = useState<string>('');
  const debounced = useDebouncedCallback(search => {
    getAllDeletedItems(search, limit, offset, tabel);
  }, 800);
  return (
    <div className="PartsStyles">
      <div className="cardWrapeer">
        <Card>
          <PageHeader>
            <Row justify="space-between">
              <Col>
                <Input.Search
                  className="search_input_control"
                  loading={recyclerLoading}
                  allowClear
                  value={search}
                  onChange={e => {
                    setSearch(e.target.value);
                    debounced(e.target.value);
                  }}
                  placeholder="Search"
                />
              </Col>
            </Row>
          </PageHeader>
          <Tabs
            defaultActiveKey="1"
            // @ts-ignore
            onChange={data => getAllDeletedItems(search, limit, offset, data)}
          >
            <TabPane style={{ color: 'white' }} tab="Parts" key="PART">
              <Part />
            </TabPane>

            <TabPane style={{ color: 'white' }} tab="Submodels" key="SUBMODEL">
              <Submodel />
            </TabPane>

            <TabPane style={{ color: 'white' }} tab="Trims" key="TRIM">
              <Trim />
            </TabPane>
          </Tabs>
        </Card>
      </div>
    </div>
  );
});

export default Parts;
